import type { TrackingFn } from '@change-corgi/core/react/tracking';

function getTrackingCommonData() {
	return {
		location: 'line',
	};
}

export function trackShareSuccess(
	eventName: string,
	trackingData: Record<string, string | number | boolean | undefined> | undefined,
	track: TrackingFn,
): void {
	void track(eventName, { ...getTrackingCommonData(), ...trackingData });
}
